<template>
  <div class="container-fluid p-0">
    <div class="card card-body px-4">
      <div class="row">
        <div class="mx-auto mt-3 col-lg-12 my-sm-auto ms-sm-auto me-sm-0">
          <div class="nav-wrapper position-relative end-0">
            <ul
              class="p-1 nav nav-pills nav-fill"
              style="background-color: #ededed"
              role="tablist"
            >
              <li
                class="nav-item"
                style="border-radius: 14px; transition: all 0.6s ease"
                :style="{
                  backgroundColor: isPageActive('account')
                    ? 'white'
                    : 'transparent',
                  boxShadow: isPageActive('account')
                    ? '0 0 10px rgba(0, 0, 0, 0.2)'
                    : 'none',
                }"
              >
                <a
                  :class="{
                    'px-0': true,
                    'py-1': true,
                    'mb-0': true,
                    'nav-link': true,
                    active: page == 'account',
                  }"
                  data-bs-toggle="tab"
                  href="javascript:;"
                  role="tab"
                  aria-selected="true"
                  @click.prevent="page = 'account'"
                >
                  <span class="ms-1">Conta</span>
                </a>
              </li>

              <li
                class="nav-item"
                style="border-radius: 14px; transition: all 0.6s ease"
                :style="{
                  backgroundColor: isPageActive('payment_methods')
                    ? 'white'
                    : 'transparent',
                  boxShadow: isPageActive('payment_methods')
                    ? '0 0 10px rgba(0, 0, 0, 0.2)'
                    : 'none',
                }"
              >
                <a
                  :class="{
                    'px-0': true,
                    'py-1': true,
                    'mb-0': true,
                    'nav-link': true,
                    active: page == 'payment_methods',
                  }"
                  data-bs-toggle="tab"
                  href="javascript:;"
                  role="tab"
                  aria-selected="true"
                  @click.prevent="page = 'payment_methods'"
                >
                  <span class="ms-1">Métodos de Pagamento</span>
                </a>
              </li>

              <li
                class="nav-item"
                style="border-radius: 14px; transition: all 0.6s ease"
                :style="{
                  backgroundColor: isPageActive('social')
                    ? 'white'
                    : 'transparent',
                  boxShadow: isPageActive('social')
                    ? '0 0 10px rgba(0, 0, 0, 0.2)'
                    : 'none',
                }"
              >
                <a
                  :class="{
                    'px-0': true,
                    'py-1': true,
                    'mb-0': true,
                    'nav-link': true,
                    active: page == 'social',
                  }"
                  data-bs-toggle="tab"
                  href="javascript:;"
                  role="tab"
                  aria-selected="true"
                  @click.prevent="page = 'social'"
                >
                  <span class="ms-1">Redes Sociais</span>
                </a>
              </li>

              <li
                class="nav-item"
                style="border-radius: 14px; transition: all 0.6s ease"
                :style="{
                  backgroundColor: isPageActive('pixel')
                    ? 'white'
                    : 'transparent',
                  boxShadow: isPageActive('pixel')
                    ? '0 0 10px rgba(0, 0, 0, 0.2)'
                    : 'none',
                }"
              >
                <a
                  :class="{
                    'px-0': true,
                    'py-1': true,
                    'mb-0': true,
                    'nav-link': true,
                    active: page == 'pixel',
                  }"
                  data-bs-toggle="tab"
                  href="javascript:;"
                  role="tab"
                  aria-selected="true"
                  @click.prevent="page = 'pixel'"
                >
                  <span class="ms-1">Pixels & Anúncios</span>
                </a>
              </li>

              <li
                class="nav-item"
                style="border-radius: 14px; transition: all 0.6s ease"
                :style="{
                  backgroundColor: isPageActive('security')
                    ? 'white'
                    : 'transparent',
                  boxShadow: isPageActive('security')
                    ? '0 0 10px rgba(0, 0, 0, 0.2)'
                    : 'none',
                }"
              >
                <a
                  :class="{
                    'px-0': true,
                    'py-1': true,
                    'mb-0': true,
                    'nav-link': true,
                    active: page == 'security',
                  }"
                  data-bs-toggle="tab"
                  href="javascript:;"
                  role="tab"
                  aria-selected="true"
                  @click.prevent="page = 'security'"
                >
                  <span class="ms-1">Segurança</span>
                </a>
              </li>

              <li
                class="nav-item"
                style="border-radius: 14px; transition: all 0.6s ease"
                :style="{
                  backgroundColor: isPageActive('customization')
                    ? 'white'
                    : 'transparent',
                  boxShadow: isPageActive('customization')
                    ? '0 0 10px rgba(0, 0, 0, 0.2)'
                    : 'none',
                }"
              >
                <a
                  :class="{
                    'px-0': true,
                    'py-1': true,
                    'mb-0': true,
                    'nav-link': true,
                    active: page == 'customization',
                  }"
                  data-bs-toggle="tab"
                  href="javascript:;"
                  role="tab"
                  aria-selected="true"
                  @click.prevent="page = 'customization'"
                >
                  <span class="ms-1">Personalização</span>
                </a>
              </li>

              <li
                class="nav-item"
                style="border-radius: 14px; transition: all 0.6s ease"
                :style="{
                  backgroundColor: isPageActive('affiliate')
                    ? 'white'
                    : 'transparent',
                  boxShadow: isPageActive('affiliate')
                    ? '0 0 10px rgba(0, 0, 0, 0.2)'
                    : 'none',
                }"
              >
                <a
                  :class="{
                    'px-0': true,
                    'py-1': true,
                    'mb-0': true,
                    'nav-link': true,
                    active: page == 'affiliate',
                  }"
                  data-bs-toggle="tab"
                  href="javascript:;"
                  role="tab"
                  aria-selected="true"
                  @click.prevent="page = 'affiliate'"
                >
                  <span class="ms-1">{{ user.is_affiliate ? 'Minha Afiliação' : 'Seja um Afiliado' }}</span>
                </a>
              </li>

              <li
                class="nav-item"
                style="border-radius: 14px; transition: all 0.6s ease"
                :style="{
                  backgroundColor: isPageActive('global_settings')
                    ? 'white'
                    : 'transparent',
                  boxShadow: isPageActive('global_settings')
                    ? '0 0 10px rgba(0, 0, 0, 0.2)'
                    : 'none',
                }"
                v-if="user.role === 'MASTER'"
              >
                <a
                  :class="{
                    'px-0': true,
                    'py-1': true,
                    'mb-0': true,
                    'nav-link': true,
                    active: page == 'global_settings',
                  }"
                  data-bs-toggle="tab"
                  href="javascript:;"
                  role="tab"
                  aria-selected="true"
                  @click.prevent="page = 'global_settings'"
                >
                  <span class="ms-1">Sistema</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div>
        <div class="mt-3 row">
          <div class="col-12 position-relative" v-if="page == 'account'">
            <div class="card card-plain h-100">
              <div class="p-3 pb-0 card-header d-flex align-items-center">
                <h6 class="mb-0">Conta</h6>
                <div v-if="user.use_plan && user.plan_active === 'ANUAL'"
                  class="ms-3 badge bg-gradient-success border-radius-lg"
                >
                  ANUAL
                </div>
                <div v-if="user.use_plan && user.plan_active === 'VITALICIO'" 
                  class="ms-3 badge-diamond-premium d-flex align-items-center"
                >
                  <i class="fas fa-gem me-1"></i>
                  DIAMOND
                </div>
              </div>
              <div class="p-3 card-body">
                <div class="account-form mb-3">
                  <div>
                    <ProfilePictureInput
                      :value="user.profile"
                      @updateUserImage="updateUserImage"
                    />
                  </div>

                  <div class="account-form-input">
                    <DefaultInput
                      v-model="user.full_name"
                      label="Nome"
                      placeholder="Insira seu nome"
                    />

                    <DefaultInput
                      v-model="user.email"
                      label="E-mail"
                      placeholder="Insira seu e-mail"
                    />

                    <div class="input-group input-group-outline m-0 d-flex flex-column">
                      <label class="input-label">
                        <span class="text-xs text-uppercase text-body font-weight-bolder"
                          >WhatsApp</span
                        >
                        <PhoneInput v-model="user.phone" />
                      </label>
                    </div>
                  </div>
                </div>

                <div class="button-field">
                  <button
                    class="btn mb-0 mt-3 submit-button"
                    @click.prevent="updateUserData"
                  >
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-12 col-md-12 col-xl-12 position-relative"
            v-if="page == 'payment_methods'"
          >
            <div class="card card-plain h-100">
              <div class="p-3 pb-0 card-header">
                <h6 class="mb-0">Métodos de Pagamento</h6>
              </div>

              <div class="p-3 card-body">
                <div class="card-payments system-wallet-card">
                  <div class="card-payments-row">
                    <div class="payment-icon system-wallet-icon">
                      <i
                        class="material-icons"
                        style="font-size: 28px; color: white"
                        >account_balance_wallet</i
                      >
                    </div>

                    <div class="payment-titles">
                      <div class="badge-field">
                        <div class="flex items-center gap-2">
                          <span class="system-wallet-title"
                            >Carteira do Sistema</span
                          >
                        </div>
                        <span v-if="user.system_wallet" class="badge-green"
                          >Ativo</span
                        >
                        <span v-else class="badge-gray">Inativo</span>
                      </div>

                      <section class="configure-buttons-field">
                        <button
                          class="btn-settings"
                          @click="showWalletInfo"
                          style="background: #f8f9fa; border: 1px solid #d2d6da"
                        >
                          <i class="material-icons" style="font-size: 16px"
                            >info</i
                          >
                          Como Funciona
                        </button>
                        <router-link
                          v-if="!user.system_wallet"
                          class="btn-settings"
                          to="/wallet/application"
                          style="text-decoration: none; color: inherit;"
                        >
                          <i class="material-icons" style="font-size: 16px"
                            >arrow_forward</i
                          >
                          Solicitar Ativação
                        </router-link>
                        <button
                          v-else
                          class="btn-settings"
                          disabled
                          style="opacity: 0.6; cursor: not-allowed"
                        >
                          <i class="material-icons" style="font-size: 16px"
                            >check</i
                          >
                          Ativado
                        </button>
                      </section>
                    </div>
                  </div>

                  <p>
                    Utilize a carteira do sistema para gerenciar suas vendas
                    automaticamente. <br />
                    <strong>Benefícios:</strong> Isenção da taxa de publicação.
                  </p>
                  <div class="d-flex flex-column">
                    <strong style="color: #661cb0">
                      Taxa: 10% por venda
                    </strong>
                    <strong style="color: #661cb0; margin-top: 4px">
                      R$4,50 por saque
                    </strong>
                  </div>

                  <div
                    class="mt-3 alert alert-warning text-white text-xs"
                    role="alert"
                    v-if="user.system_wallet"
                  >
                    <strong>Aviso:</strong> Para desativar a carteira do
                    sistema, entre em contato com o suporte.
                  </div>
                </div>

                <!-- <div
                  class="card-payments"
                  :class="{ 'disabled-payment': user.system_wallet }"
                >
                  <div class="card-payments-row">
                    <div class="payment-icon">
                      <img
                        class="payment-logo"
                        src="@/assets/img/payments/Fluxsis.png"
                      />
                    </div>

                    <div class="payment-titles">
                      <div class="badge-field">
                        <span>Fluxsis</span>
                        <span class="badge-golden">💎 Melhor opção!</span>
                        <span class="badge-green">Baixa automática</span>
                      </div>

                      <section class="configure-buttons-field">
                        <button
                          v-if="showDefaultPaymentTypeButton('ONZ')"
                          class="btn-settings"
                          :disabled="
                            isDefaultProvider('ONZ') || user.system_wallet
                          "
                          @click="setDefaultPaymentProvider('ONZ')"
                        >
                          <i
                            v-if="isDefaultProvider('ONZ')"
                            class="material-icons"
                            style="font-size: 16px"
                            >check_circle</i
                          >
                          {{
                            isDefaultProvider("ONZ")
                              ? "Método padrão"
                              : "Definir como padrão"
                          }}
                        </button>
                        <button
                          class="btn-settings"
                          :disabled="user.system_wallet"
                          @click="modalFluxsis = true"
                        >
                          <i class="material-icons" style="font-size: 16px"
                            >settings</i
                          >
                          Configurar
                        </button>
                      </section>
                    </div>
                  </div>

                  <p>
                    Receba pagamentos via Pix diretamente na sua conta da
                    Fluxsis.
                  </p>
                  <strong style="color: #5900b2"> Taxa: 2% + R$ 0,10 </strong>
                </div> -->

                <!-- <div class="card-payments">
                  <div class="card-payments-row">
                    <div class="payment-icon">
                      <img class="payment-logo" src="@/assets/img/payments/paggue.svg">
                    </div>

                    <div class="payment-titles">
                      <div class="badge-field">
                        <span>Paggue</span>
                        <span class="badge-green">Baixa automática</span>
                      </div>

                      <section class="configure-buttons-field">
                        <button v-if="showDefaultPaymentTypeButton('PAGGUE')" class="btn-settings" :disabled="isDefaultProvider('PAGGUE')" @click="setDefaultPaymentProvider('PAGGUE')">
                          <i v-if="isDefaultProvider('PAGGUE')" class="material-icons" style="font-size: 16px;">check_circle</i>
                          {{ isDefaultProvider('PAGGUE') ? 'Método padrão' : 'Definir como padrão' }}
                        </button>
                        <button class="btn-settings" @click="modalPaggue = true">
                          <i class="material-icons" style="font-size: 16px;">settings</i>
                          Configurar
                        </button>
                      </section>
                    </div>
                  </div>

                  <p>
                    Receba pagamentos via Pix diretamente na sua conta do Paggue.
                  </p>
                  <div class="verTaxas">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-4">
                      <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"/>
                    </svg>
                    <a title="ver taxas deste método de pagamento" alt="ver taxas deste método de pagamento" class="font-extrabold" href="https://paggue.io/" target="_blank">Ver taxas </a>
                  </div>
                </div> -->

                <div
                  class="card-payments"
                  :class="{ 'disabled-payment': user.system_wallet }"
                >
                  <div class="card-payments-row">
                    <div class="payment-icon">
                      <img
                        class="payment-logo"
                        src="@/assets/img/payments/pay2m.png"
                        alt=""
                      />
                    </div>

                    <div class="payment-titles">
                      <div class="badge-field">
                        <span>Pay2m</span>
                        <span class="badge-green">Baixa automática</span>
                      </div>

                      <section class="configure-buttons-field">
                        <button
                          v-if="showDefaultPaymentTypeButton('PAY2M')"
                          class="btn-settings"
                          :disabled="
                            isDefaultProvider('PAY2M') || user.system_wallet
                          "
                          @click="setDefaultPaymentProvider('PAY2M')"
                        >
                          <i
                            v-if="isDefaultProvider('PAY2M')"
                            class="material-icons"
                            style="font-size: 16px"
                            >check_circle</i
                          >
                          {{
                            isDefaultProvider("PAY2M")
                              ? "Método padrão"
                              : "Definir como padrão"
                          }}
                        </button>
                        <button
                          class="btn-settings"
                          :disabled="user.system_wallet"
                          @click="modalPixPay2m = true"
                        >
                          <i class="material-icons" style="font-size: 16px"
                            >settings</i
                          >
                          Configurar
                        </button>
                      </section>
                    </div>
                  </div>

                  <p>
                    Receba pagamentos via Pix diretamente na sua conta do Pay2M.
                  </p>

                  <strong style="color: #5900b2"> Taxa: 2,5% por Pix </strong>
                  <div style="margin-top: 14px;">
                    <a
                      href="https://portal.pay2m.com.br/users/sign_up"
                      target="_blank"
                      class="btn mb-0 d-flex align-items-center justify-content-center"
                      style="
                        background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
                        color: white;
                        text-transform: none;
                        font-size: 14px;
                        padding: 8px 16px;
                        border-radius: 8px;
                        box-shadow: 0 4px 6px rgba(15, 23, 42, 0.25);
                        gap: 6px;
                        width: max-content;
                      "
                    >
                      <i class="material-icons" style="font-size: 18px">person_add</i>
                      Criar conta Pay2M
                    </a>
                  </div>
                </div>

                <div
                  class="card-payments"
                  :class="{ 'disabled-payment': user.system_wallet }"
                >
                  <div class="card-payments-row">
                    <div class="payment-icon">
                      <img
                        class="payment-logo"
                        src="@/assets/img/payments/efipay.png"
                        alt="EFIPAY"
                      />
                    </div>

                    <div class="payment-titles">
                      <div class="badge-field">
                        <span>EFIPAY</span>
                        <span class="badge-green">Baixa automática</span>
                      </div>

                      <section class="configure-buttons-field">
                        <button
                          v-if="showDefaultPaymentTypeButton('EFIPAY')"
                          class="btn-settings"
                          :disabled="
                            isDefaultProvider('EFIPAY') || user.system_wallet
                          "
                          @click="setDefaultPaymentProvider('EFIPAY')"
                        >
                          <i
                            v-if="isDefaultProvider('EFIPAY')"
                            class="material-icons"
                            style="font-size: 16px"
                            >check_circle</i
                          >
                          {{
                            isDefaultProvider("EFIPAY")
                              ? "Método padrão"
                              : "Definir como padrão"
                          }}
                        </button>
                        <button
                          class="btn-settings"
                          :disabled="user.system_wallet"
                          @click="modalEfipay = true"
                        >
                          <i class="material-icons" style="font-size: 16px"
                            >settings</i
                          >
                          Configurar
                        </button>
                      </section>
                    </div>
                  </div>

                  <p>
                    Receba pagamentos via Pix diretamente na sua conta EFIPAY.
                  </p>
                  <strong style="color: #5900b2">Taxa: 1,19% por Pix</strong>
                  <div style="margin-top: 14px;">
                    <a
                      href="https://sejaefi.com.br/abrir-conta"
                      target="_blank"
                      class="btn mb-0 d-flex align-items-center justify-content-center"
                      style="
                        background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
                        color: white;
                        text-transform: none;
                        font-size: 14px;
                        padding: 8px 16px;
                        border-radius: 8px;
                        box-shadow: 0 4px 6px rgba(234, 88, 12, 0.25);
                        gap: 6px;
                        width: max-content;
                      "
                    >
                      <i class="material-icons" style="font-size: 18px">person_add</i>
                      Criar conta EfiPay
                    </a>
                  </div>
                </div>

                <div
                  class="card-payments"
                  :class="{ 'disabled-payment': user.system_wallet }"
                >
                  <div class="card-payments-row">
                    <div class="payment-icon">
                      <img
                        class="payment-logo"
                        src="@/assets/img/payments/zettpay.png"
                        alt="ZettPay"
                      />
                    </div>

                    <div class="payment-titles">
                      <div class="badge-field">
                        <span>ZettPay</span>
                        <span class="badge-green">Baixa automática</span>
                      </div>

                      <section class="configure-buttons-field">
                        <button
                          v-if="showDefaultPaymentTypeButton('ZETT')"
                          class="btn-settings"
                          :disabled="
                            isDefaultProvider('ZETT') || user.system_wallet
                          "
                          @click="setDefaultPaymentProvider('ZETT')"
                        >
                          <i
                            v-if="isDefaultProvider('ZETT')"
                            class="material-icons"
                            style="font-size: 16px"
                            >check_circle</i
                          >
                          {{
                            isDefaultProvider("ZETT")
                              ? "Método padrão"
                              : "Definir como padrão"
                          }}
                        </button>
                        <button
                          class="btn-settings"
                          :disabled="user.system_wallet"
                          @click="modalZett = true"
                        >
                          <i class="material-icons" style="font-size: 16px"
                            >settings</i
                          >
                          Configurar
                        </button>
                      </section>
                    </div>
                  </div>

                  <p>
                    Receba pagamentos via Pix diretamente na sua conta ZettPay.
                  </p>
                  <strong style="color: #5900b2">Taxa: 3,99% por Pix</strong>
                  <div style="margin-top: 14px;">
                    <a
                      href="https://finance.zettpay.io/register/rifa365"
                      target="_blank"
                      class="btn mb-0 d-flex align-items-center justify-content-center"
                      style="
                        background: linear-gradient(135deg, #0066cc 0%, #004c99 100%);
                        color: white;
                        text-transform: none;
                        font-size: 14px;
                        padding: 8px 16px;
                        border-radius: 8px;
                        box-shadow: 0 4px 6px rgba(0, 102, 204, 0.25);
                        gap: 6px;
                        width: max-content;
                      "
                    >
                      <i class="material-icons" style="font-size: 18px">person_add</i>
                      Criar conta ZettPay
                    </a>
                  </div>
                </div>

                <div
                  class="card-payments"
                  :class="{ 'disabled-payment': user.system_wallet }"
                >
                  <div class="card-payments-row">
                    <div class="payment-icon">
                      <img
                        class="payment-logo"
                        src="@/assets/img/payments/paggo365.png"
                        alt="Paggo365"
                      />
                    </div>

                    <div class="payment-titles">
                      <div class="badge-field">
                        <span>Paggo365</span>
                        <span class="badge-green">Baixa automática</span>
                      </div>

                      <section class="configure-buttons-field">
                        <button
                          v-if="showDefaultPaymentTypeButton('PAGGO365')"
                          class="btn-settings"
                          :disabled="
                            isDefaultProvider('PAGGO365') || user.system_wallet
                          "
                          @click="setDefaultPaymentProvider('PAGGO365')"
                        >
                          <i
                            v-if="isDefaultProvider('PAGGO365')"
                            class="material-icons"
                            style="font-size: 16px"
                            >check_circle</i
                          >
                          {{
                            isDefaultProvider("PAGGO365")
                              ? "Método padrão"
                              : "Definir como padrão"
                          }}
                        </button>
                        <button
                          class="btn-settings"
                          :disabled="user.system_wallet"
                          @click="modalPaggo365 = true"
                        >
                          <i class="material-icons" style="font-size: 16px"
                            >settings</i
                          >
                          Configurar
                        </button>
                      </section>
                    </div>
                  </div>

                  <p>
                    Receba pagamentos via Pix diretamente na sua conta Paggo365.
                  </p>
                  <strong style="color: #5900b2">Taxa: 2,99% por Pix</strong>
                  <strong style="color: #b45309; display: block; margin-top: 4px">
                    Valor mínimo por compra: R$ 5,00
                  </strong>
                  <div style="margin-top: 14px">
                    <a
                      href="https://app.paggo365.com/cadastro"
                      target="_blank"
                      class="btn mb-0 d-flex align-items-center justify-content-center"
                      style="
                        background: linear-gradient(135deg, #0050fc 0%, #003bb8 100%);
                        color: white;
                        text-transform: none;
                        font-size: 14px;
                        padding: 8px 16px;
                        border-radius: 8px;
                        box-shadow: 0 4px 6px rgba(0, 80, 252, 0.25);
                        gap: 6px;
                        width: max-content;
                      "
                    >
                      <i class="material-icons" style="font-size: 18px">person_add</i>
                      Criar conta Paggo365
                    </a>
                  </div>
                </div>

                <div
                  class="card-payments"
                  :class="{ 'disabled-payment': user.system_wallet }"
                >
                  <div class="card-payments-row">
                    <div class="payment-icon">
                      <img
                        class="payment-logo"
                        src="@/assets/img/payments/pix.svg"
                      />
                    </div>

                    <div class="payment-titles">
                      <div class="badge-field">
                        <span>Pix</span>
                        <span class="badge-orange">Baixa manual</span>
                      </div>

                      <section class="configure-buttons-field">
                        <button
                          v-if="showDefaultPaymentTypeButton('MANUAL')"
                          class="btn-settings"
                          :disabled="
                            isDefaultProvider('MANUAL') || user.system_wallet
                          "
                          @click="setDefaultPaymentProvider('MANUAL')"
                        >
                          <i
                            v-if="isDefaultProvider('MANUAL')"
                            class="material-icons"
                            style="font-size: 16px"
                            >check_circle</i
                          >
                          {{
                            isDefaultProvider("MANUAL")
                              ? "Método padrão"
                              : "Definir como padrão"
                          }}
                        </button>
                        <button
                          class="btn-settings"
                          :disabled="user.system_wallet"
                          @click="modalPixManual = true"
                        >
                          <i class="material-icons" style="font-size: 16px"
                            >settings</i
                          >
                          Configurar
                        </button>
                      </section>
                    </div>
                  </div>

                  <p>Receba pagamentos via Pix diretamente na sua conta.</p>
                </div>

                <div
                  class="card-payments"
                  :class="{ 'disabled-payment': user.system_wallet }"
                >
                  <div class="card-payments-row">
                    <div class="payment-icon">
                      <i
                        class="material-icons"
                        style="font-size: 40px; color: #f7931a"
                        >currency_bitcoin</i
                      >
                    </div>

                    <div class="payment-titles">
                      <div class="badge-field">
                        <span>Crypto</span>
                        <span class="badge-orange">Baixa manual</span>
                      </div>

                      <section class="configure-buttons-field">
                        <button
                          v-if="showDefaultPaymentTypeButton('CRYPTO')"
                          class="btn-settings"
                          :disabled="
                            isDefaultProvider('CRYPTO') || user.system_wallet
                          "
                          @click="setDefaultPaymentProvider('CRYPTO')"
                        >
                          <i
                            v-if="isDefaultProvider('CRYPTO')"
                            class="material-icons"
                            style="font-size: 16px"
                            >check_circle</i
                          >
                          {{
                            isDefaultProvider("CRYPTO")
                              ? "Método padrão"
                              : "Definir como padrão"
                          }}
                        </button>
                        <button
                          class="btn-settings"
                          :disabled="user.system_wallet"
                          @click="modalCrypto = true"
                        >
                          <i class="material-icons" style="font-size: 16px"
                            >settings</i
                          >
                          Configurar
                        </button>
                      </section>
                    </div>
                  </div>

                  <p>
                    Receba USDT/BTC na sua carteira — ideal para público fora do
                    Brasil. Confirmação manual, como o Pix manual.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-12 col-md-12 col-xl-12 position-relative"
            v-if="page == 'social'"
          >
            <div class="card card-plain h-100">
              <div class="p-3 pb-0 card-header">
                <h6 class="mb-0">Redes Sociais</h6>
              </div>
              <div class="p-3 card-body social-medias">
                <DefaultInput
                  v-model="user.whatsapp"
                  label="Grupo no WhatsApp"
                  placeholder="Digite o link aqui..."
                  class="mb-2"
                />
                <div class="form-check form-switch mb-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="waGroupPopupEnabled"
                    v-model="user.whatsapp_group_popup_enabled"
                  />
                  <label class="form-check-label text-sm" for="waGroupPopupEnabled">
                    Exibir popup do grupo na página da campanha
                  </label>
                </div>
                <p class="text-xs text-secondary mb-3" style="margin-top: -4px">
                  Com o link preenchido e a opção ativa, o visitante vê um popup convidando a entrar no grupo (usa a cor do tema do site).
                </p>

                <DefaultInput
                  v-model="user.telegram"
                  label="Grupo no Telegram"
                  placeholder="Digite o link aqui..."
                  class="mb-2"
                />

                <DefaultInput
                  v-model="user.instagram"
                  label="Perfil no Instagram"
                  placeholder="Digite o link aqui..."
                  class="mb-2"
                />

                <DefaultInput
                  v-model="user.tiktok"
                  label="Perfil no Tiktok"
                  placeholder="Digite o link aqui..."
                  class="mb-2"
                />

                <DefaultInput
                  v-model="user.youtube"
                  label="Canal no Youtube"
                  placeholder="Digite o link aqui..."
                  class="mb-2"
                />
              </div>

              <div class="button-field mb-4">
                <button
                  class="btn mb-0 mt-3 submit-button"
                  @click.prevent="updateUserData"
                >
                  Salvar
                </button>
              </div>
            </div>
          </div>

          <div
            class="col-12 col-md-12 col-xl-12 position-relative"
            v-if="page == 'pixel'"
          >
            <div class="card card-plain h-100 px-shell">
              <div class="p-3 pb-0 card-header">
                <h6 class="mb-0">Pixels & Anúncios</h6>
                <p class="text-sm text-secondary mb-0">
                  Conecte pixels para medir e otimizar campanhas. O evento de
                  compra só dispara após o pagamento aprovado.
                </p>
              </div>
              <div class="p-3 card-body">
                <div class="px-grid">
                  <article
                    v-for="item in pixelIntegrations"
                    :key="item.key"
                    class="px-card"
                    :class="{ 'px-card--soon': item.soon }"
                  >
                    <div class="px-card-top">
                      <div class="px-card-icon">
                        <img :src="item.icon" :alt="item.name" />
                      </div>
                      <div class="px-card-copy">
                        <div class="px-card-title-row">
                          <h6 class="px-card-title mb-0">{{ item.name }}</h6>
                          <span
                            v-if="item.soon"
                            class="px-badge px-badge--soon"
                            >Em breve</span
                          >
                          <span
                            v-else-if="isPixelConfigured(item.key)"
                            class="px-badge px-badge--ok"
                            >Configurado</span
                          >
                        </div>
                        <p class="px-card-desc mb-0">{{ item.description }}</p>
                      </div>
                    </div>
                    <button
                      v-if="!item.soon"
                      type="button"
                      class="px-btn"
                      @click="openPixelModal(item.key)"
                    >
                      {{
                        isPixelConfigured(item.key)
                          ? "Configurar"
                          : "Adicionar"
                      }}
                    </button>
                    <button
                      v-else
                      type="button"
                      class="px-btn px-btn--disabled"
                      disabled
                    >
                      Em breve
                    </button>
                  </article>
                </div>
              </div>
            </div>

            <div
              v-if="pixelModal.open"
              class="px-modal-backdrop"
              @click.self="closePixelModal"
            >
              <div class="px-modal" role="dialog" aria-modal="true">
                <div class="px-modal-header">
                  <h6 class="mb-0">{{ pixelModalTitle }}</h6>
                  <button
                    type="button"
                    class="px-modal-close"
                    @click="closePixelModal"
                    aria-label="Fechar"
                  >
                    <i class="material-icons">close</i>
                  </button>
                </div>
                <div class="px-modal-body">
                  <DefaultInput
                    v-if="pixelModal.key === 'meta'"
                    v-model="pixelModal.pixel_fb"
                    label="Pixel ID (Meta)"
                    placeholder="Ex: 123456789012345"
                    class="mb-2"
                  />
                  <DefaultInput
                    v-if="pixelModal.key === 'meta'"
                    v-model="pixelModal.meta_capi_token"
                    label="Access Token CAPI (opcional)"
                    placeholder="Token da Conversions API"
                    class="mb-2"
                  />
                  <p
                    v-if="pixelModal.key === 'meta'"
                    class="text-xs text-secondary mb-0"
                  >
                    Com o token, o Purchase também é enviado pelo servidor no
                    pagamento aprovado (mesmo event_id do navegador).
                  </p>
                  <DefaultInput
                    v-if="pixelModal.key === 'google'"
                    v-model="pixelModal.gtag"
                    label="Google Ads / gtag ID"
                    placeholder="Ex: AW-1234567890"
                    class="mb-2"
                  />
                  <DefaultInput
                    v-if="pixelModal.key === 'tiktok'"
                    v-model="pixelModal.pixel_tiktok"
                    label="TikTok Pixel ID"
                    placeholder="Ex: CXXXXXXXXXXXXXXX"
                    class="mb-2"
                  />
                </div>
                <div class="px-modal-footer">
                  <button
                    type="button"
                    class="px-btn px-btn--ghost"
                    @click="closePixelModal"
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    class="px-btn px-btn--primary"
                    @click="savePixelModal"
                    :disabled="savingPixel"
                  >
                    {{ savingPixel ? "Salvando..." : "Salvar" }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="m-0 p-0" v-if="page == 'customization'">
            <div class="card card-plain h-100">
              <div class="p-3 pb-0 card-header">
                <h6 class="mb-0">Personalização</h6>
              </div>
              <div class="p-3 card-body">
                <div class="account-form mb-3">
                  <div>
                    <ImageInput
                      :value="user.logo"
                      @updateUserImage="updateLogoImage"
                    />
                  </div>

                  <div class="account-form-input mb-4">
                    <p class="text-sm font-weight-bold mb-1">Cores da marca</p>
                    <p class="text-xs text-secondary mb-3">
                      Defina as cores usadas na página pública da campanha e na página de ganhadores.
                      Deixe em branco para usar o padrão Rifa365.
                    </p>
                    <div class="theme-colors-row">
                      <div class="theme-color-field">
                        <label class="form-label text-xs mb-1">Cor principal</label>
                        <div class="theme-color-controls">
                          <input
                            type="color"
                            class="theme-color-picker"
                            :value="themePrimary || '#5900b2'"
                            @input="onThemePrimaryPick"
                          />
                          <input
                            type="text"
                            class="form-control theme-color-hex"
                            v-model="themePrimary"
                            placeholder="#5900b2"
                            maxlength="7"
                          />
                        </div>
                      </div>
                      <div class="theme-color-field">
                        <label class="form-label text-xs mb-1">Cor de destaque</label>
                        <div class="theme-color-controls">
                          <input
                            type="color"
                            class="theme-color-picker"
                            :value="themeAccent || '#fb1789'"
                            @input="onThemeAccentPick"
                          />
                          <input
                            type="text"
                            class="form-control theme-color-hex"
                            v-model="themeAccent"
                            placeholder="#fb1789"
                            maxlength="7"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="theme-preview mt-3"
                      :style="{
                        background: `linear-gradient(135deg, ${themePrimary || '#5900b2'} 0%, ${themeAccent || '#fb1789'} 100%)`,
                      }"
                    >
                      Prévia do gradiente
                    </div>
                    <button
                      class="btn mb-0 mt-3 submit-button"
                      @click.prevent="saveTheme"
                      :disabled="savingTheme"
                    >
                      {{ savingTheme ? 'Salvando...' : 'Salvar cores' }}
                    </button>
                  </div>

                  <div class="account-form-input">
                    <DefaultInput
                      v-model="domainForm"
                      label="Domínio personalizado"
                      placeholder="ex: meudominio.com.br"
                      class="mb-2"
                    />

                    <div class="domain-help mb-3">
                      <p class="text-xs text-secondary mb-2">
                        Cadastre seu <strong>domínio personalizado</strong> aqui (sem <code>https://</code>).
                        Ao salvar, o domínio entra no projeto automaticamente e mostramos os registros DNS
                        para você colar na <strong>Cloudflare</strong> (ou na sua registradora).
                      </p>

                      <div class="domain-dns-card mb-3">
                        <div class="d-flex align-items-center justify-content-between gap-2 mb-2 flex-wrap">
                          <p class="text-xxs text-uppercase text-secondary font-weight-bolder mb-0">
                            Apontamentos DNS sugeridos (Vercel)
                          </p>
                          <button
                            type="button"
                            class="domain-video-flag"
                            @click="openDomainTutorialModal"
                            title="Ver vídeo do passo a passo"
                          >
                            <i class="material-icons">play_circle</i>
                            <span>Vídeo</span>
                          </button>
                        </div>
                        <div class="table-responsive">
                          <table class="table table-sm align-items-center mb-0 domain-dns-table">
                            <thead>
                              <tr>
                                <th class="text-xxs text-uppercase">Tipo</th>
                                <th class="text-xxs text-uppercase">Nome</th>
                                <th class="text-xxs text-uppercase">Valor / Conteúdo</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="row in domainDnsRecords" :key="row.type + row.name">
                                <td><span class="badge badge-sm bg-gradient-dark">{{ row.type }}</span></td>
                                <td class="text-xs font-weight-bold">{{ row.name }}</td>
                                <td class="text-xs">
                                  <code>{{ row.value }}</code>
                                  <button
                                    type="button"
                                    class="btn btn-link btn-sm p-0 ms-2 text-xxs"
                                    @click="copyDnsValue(row.value)"
                                  >
                                    copiar
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <p class="text-xxs text-secondary mb-0 mt-2">
                          Após apontar na Cloudflare/registradora, a propagação pode levar de alguns minutos
                          até cerca de 2 horas. Quando o DNS estiver ok, o domínio libera sozinho.
                        </p>
                      </div>

                      <ol class="text-xs text-secondary ps-3 mb-2">
                        <li>Salve o domínio personalizado neste campo.</li>
                        <li>No popup, copie os registros e cole na Cloudflare (DNS).</li>
                        <li>Aguarde a propagação e o SSL.</li>
                        <li>Seus links passam a usar <strong>https://seu-dominio/c/codigo</strong>.</li>
                      </ol>
                      <p class="text-xxs text-secondary mb-0" v-if="user.domain">
                        Domínio personalizado atual: <strong>{{ user.domain }}</strong>
                      </p>
                    </div>

                    <div class="d-flex gap-2 flex-wrap">
                      <button
                        class="btn mb-0 mt-1 submit-button"
                        @click.prevent="saveDomain"
                        :disabled="savingDomain"
                      >
                        {{ savingDomain ? 'Salvando...' : 'Salvar domínio personalizado' }}
                      </button>
                      <button
                        v-if="user.domain"
                        type="button"
                        class="btn btn-outline-secondary mb-0 mt-1"
                        @click.prevent="clearDomain"
                        :disabled="savingDomain"
                      >
                        Remover domínio personalizado
                      </button>
                    </div>
                  </div>
                </div>

                <div class="button-field">
                  <button
                    class="btn mb-0 mt-3 submit-button"
                    @click.prevent="updateUserData"
                  >
                    Salvar logo
                  </button>
                </div>
              </div>
            </div>
            <hr class="vertical dark" />
          </div>

          <div
            class="col-12 col-md-12 col-xl-12 position-relative"
            v-if="page == 'security'"
          >
            <div class="card card-plain h-100 sec-shell">
              <div class="p-3 pb-0 card-header">
                <h6 class="mb-0">Segurança da Conta</h6>
                <p class="text-sm text-secondary mb-0">
                  Proteja o acesso ao painel com verificação em duas etapas.
                </p>
              </div>
              <div class="p-3 card-body">
                <div
                  class="sec-hero"
                  :class="user.two_fa_enabled ? 'sec-hero--on' : 'sec-hero--off'"
                >
                  <div class="sec-hero-main">
                    <div
                      class="sec-hero-icon"
                      :class="user.two_fa_enabled ? 'is-on' : 'is-off'"
                    >
                      <i class="material-icons">{{
                        user.two_fa_enabled ? "verified_user" : "shield"
                      }}</i>
                    </div>
                    <div class="sec-hero-copy">
                      <div class="sec-hero-title-row">
                        <h5 class="sec-hero-title mb-0">
                          Autenticação de dois fatores
                        </h5>
                        <span
                          v-if="user.two_fa_enabled"
                          class="sec-badge sec-badge--ok"
                        >
                          Ativo
                        </span>
                        <span v-else class="sec-badge sec-badge--off"
                          >Inativo</span
                        >
                      </div>
                      <p class="sec-hero-desc mb-0">
                        <template v-if="user.two_fa_enabled">
                          Método em uso:
                          <strong>{{
                            user.two_fa_method === "totp"
                              ? "App autenticador"
                              : "WhatsApp + e-mail"
                          }}</strong
                          >. Cada login vai pedir um código de 6 dígitos.
                        </template>
                        <template v-else>
                          Escolha um método abaixo para exigir um código extra
                          no login e reduzir o risco de acesso indevido.
                        </template>
                      </p>
                    </div>
                  </div>
                  <button
                    v-if="user.two_fa_enabled"
                    type="button"
                    class="sec-btn sec-btn--danger"
                    @click="disable2FA"
                  >
                    <i class="material-icons">lock_open</i>
                    Desativar 2FA
                  </button>
                </div>

                <div v-if="!user.two_fa_enabled" class="sec-methods">
                  <article class="sec-method">
                    <div class="sec-method-top">
                      <div class="sec-method-icon sec-method-icon--wa">
                        <i class="fab fa-whatsapp"></i>
                      </div>
                      <div>
                        <h6 class="sec-method-title mb-1">WhatsApp + e-mail</h6>
                        <p class="sec-method-desc mb-0">
                          Código de 6 dígitos enviado nos dois canais a cada
                          login.
                        </p>
                      </div>
                    </div>
                    <div class="sec-method-meta">
                      <i class="material-icons">phone_iphone</i>
                      <span
                        >Número cadastrado:
                        <strong>{{ user.phone || "—" }}</strong></span
                      >
                    </div>
                    <button
                      type="button"
                      class="sec-btn sec-btn--primary"
                      @click="send2FACode"
                      :disabled="sending2FA"
                    >
                      <i class="material-icons">{{
                        sending2FA ? "sync" : "send"
                      }}</i>
                      {{ sending2FA ? "Enviando..." : "Ativar este método" }}
                    </button>
                  </article>

                  <article class="sec-method">
                    <div class="sec-method-top">
                      <div class="sec-method-icon sec-method-icon--totp">
                        <i class="material-icons">phonelink_lock</i>
                      </div>
                      <div>
                        <h6 class="sec-method-title mb-1">App autenticador</h6>
                        <p class="sec-method-desc mb-0">
                          Google Authenticator, Authy e similares — funciona
                          offline, sem depender de WhatsApp.
                        </p>
                      </div>
                    </div>
                    <div class="sec-method-meta sec-method-meta--muted">
                      <i class="material-icons">tips_and_updates</i>
                      <span>Recomendado para mais agilidade no dia a dia.</span>
                    </div>
                    <button
                      type="button"
                      class="sec-btn sec-btn--primary"
                      @click="setupTotp"
                      :disabled="sendingTotp"
                    >
                      <i class="material-icons">{{
                        sendingTotp ? "sync" : "qr_code_2"
                      }}</i>
                      {{
                        sendingTotp ? "Gerando QR..." : "Ativar autenticador"
                      }}
                    </button>
                  </article>
                </div>
              </div>

              <div
                v-if="user.role !== 'ADMIN'"
                class="sec-delete mt-4 p-3"
              >
                <h6 class="mb-1">Excluir conta</h6>
                <p class="text-sm text-secondary mb-3">
                  Esta ação é irreversível. Prosseguindo, iremos anonimizar seus
                  dados pessoais e bloquear o acesso ao sistema. Histórico
                  operacional pode ser mantido por obrigação legal.
                </p>
                <label class="sec-delete-label" for="delete-account-confirm"
                  >Confirmar exclusão</label
                >
                <input
                  id="delete-account-confirm"
                  type="text"
                  class="sec-delete-input mb-2"
                  v-model="deleteAccountConfirmation"
                  placeholder="Digite: Autorizo excluir minha conta"
                  autocomplete="off"
                />
                <p class="sec-delete-hint mb-3">
                  Digite no campo acima
                  <strong>Autorizo excluir minha conta</strong>
                </p>
                <label class="sec-delete-label" for="delete-account-password"
                  >Senha atual</label
                >
                <input
                  id="delete-account-password"
                  type="password"
                  class="sec-delete-input mb-3"
                  v-model="deleteAccountPassword"
                  placeholder="Sua senha"
                  autocomplete="current-password"
                  @keyup.enter="confirmDeleteAccount"
                />
                <div class="d-flex justify-content-end">
                  <button
                    type="button"
                    class="sec-delete-btn"
                    :disabled="!canDeleteAccount || deletingAccount"
                    @click="confirmDeleteAccount"
                  >
                    {{ deletingAccount ? "Excluindo..." : "Excluir" }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-12 col-xl-12 position-relative" v-if="page == 'affiliate'">
            <div class="card card-plain h-100">
              <div class="p-3 pb-0 card-header d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="mb-0">Afiliado da plataforma</h6>
                  <p class="text-xs text-secondary mb-0 mt-1">Indique quem cria conta no Rifa365. Não é o marketplace de campanhas.</p>
                </div>
                <button class="btn btn-sm btn-outline-primary mb-0" @click="modalAffiliateInfo = true">
                  <i class="material-icons" style="font-size: 14px; vertical-align: middle;">help_outline</i> Como Funciona
                </button>
              </div>
              <div class="p-3 card-body">
                <div v-if="!user.is_affiliate" class="text-center mt-4">
                  <h5 class="mb-3">Torne-se afiliado da plataforma</h5>
                  <p class="mb-2">
                    Compartilhe seu link no YouTube, Instagram ou WhatsApp.
                    Quando o indicado pagar a <strong>taxa</strong> ou ativar o <strong>plano</strong>,
                    você ganha <strong>50%</strong> (e mais %, conforme o nível).
                  </p>
                  <p class="text-sm text-secondary mb-4">
                    Não precisa de carteira do sistema nas rifas — a comissão cai no seu saldo em Meus Indicados.
                  </p>
                  <button class="submit-button mx-auto" style="border: none; border-radius: 8px; padding: 10px 20px" @click.prevent="toggleAffiliateStatus">
                    Tornar-se Afiliado Agora
                  </button>
                </div>
                
                <div v-else class="text-center mt-4">
                  <div class="mb-4">
                    <span class="badge" style="background-color: #4caf50; font-size: 14px; color: white; padding: 5px 10px; border-radius: 6px;">Afiliado Ativo ✓</span>
                  </div>
                  <p class="mb-2">Compartilhe o seu link exclusivo para indicar novos usuários:</p>
                  <div class="input-group input-group-outline mb-3" style="max-width: 500px; margin: 0 auto;">
                    <input type="text" class="form-control text-center font-weight-bold" style="border: 1px solid #d2d6da !important" :value="affiliateLink" readonly>
                  </div>
                  <div class="d-flex flex-wrap gap-2 justify-content-center mb-2">
                    <button class="submit-button" style="border: none; border-radius: 8px; padding: 10px 20px" @click.prevent="copyAffiliateLink">
                      Copiar Link
                    </button>
                    <router-link to="/meus-indicados" class="btn btn-outline-dark mb-0" style="border-radius: 8px; padding: 10px 20px; text-decoration: none;">
                      Ver painel e níveis
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-12 col-xl-12 position-relative" v-if="page == 'global_settings' && user.role === 'MASTER'">
            <div class="card card-plain h-100">
              <div class="p-3 pb-0 card-header">
                <h6 class="mb-0">Configurações Globais do Sistema</h6>
              </div>
              <div class="p-3 card-body">
                <div class="account-form mb-3">
                  <div class="account-form-input">
                    <p class="text-xs text-secondary mb-2">
                      Modelo atual: comissão única na 1ª taxa/plano do indicado + bônus por níveis (10 / 30 / 50 / 100 ativações → 55% / 60% / 65% / 70%).
                    </p>
                    <DefaultInput
                      v-model="globalSettings.affiliate_percent_first_fee"
                      type="number"
                      label="Comissão da 1ª taxa / plano (%)"
                      placeholder="Ex: 50"
                      class="mb-3"
                    />
                    <DefaultInput
                      v-model="globalSettings.affiliate_plan_fee_base"
                      type="number"
                      label="Base do plano para comissão (R$)"
                      placeholder="Ex: 97"
                      class="mb-3"
                    />
                    <DefaultInput
                      v-model="globalSettings.remarketing_fee_base"
                      type="number"
                      label="Preço mensal do Remarketing (R$)"
                      placeholder="Ex: 47"
                      class="mb-3"
                    />
                    <p class="text-xs text-secondary mb-2">Legado (não usado no MVP da 1ª taxa):</p>
                    <DefaultInput
                      v-model="globalSettings.affiliate_percent_system_wallet"
                      type="number"
                      label="[Legado] % carteira / cota"
                      placeholder="Ex: 10"
                      class="mb-3"
                    />

                    <DefaultInput
                      v-model="globalSettings.affiliate_percent_other_method"
                      type="number"
                      label="[Legado] % outros métodos / taxa"
                      placeholder="Ex: 30"
                      class="mb-3"
                    />
                  </div>
                </div>

                <div class="button-field">
                  <button
                    class="btn mb-0 mt-3 submit-button"
                    @click.prevent="saveGlobalSettings"
                  >
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <FluxsisFormDialog
      :isOpen="modalFluxsis"
      @close="modalFluxsis = false"
      v-model:fluxsisForm="onz"
      :receivedFluxsis="onz"
      @updatePayment="updateCredentials('onz')"
    />

    <PaggueFormDialog
      :isOpen="modalPaggue"
      @close="modalPaggue = false"
      v-model:paggueForm="paggue"
      :receivedPaggue="paggue"
      @updatePayment="updateCredentials('paggue')"
    />

    <Pay2mFormDialog
      :isOpen="modalPixPay2m"
      @close="modalPixPay2m = false"
      v-model:pay2mForm="pay2m"
      :receivedPay2m="pay2m"
      @updatePayment="updateCredentials('pay2m')"
    />

    <PixFormDialog
      :isOpen="modalPixManual"
      @close="modalPixManual = false"
      v-model:pixForm="manual"
      :receivedPixForm="manual"
      :loading="loading"
      @updatePayment="updateCredentials('manual')"
    />

    <CryptoFormDialog
      :isOpen="modalCrypto"
      @close="modalCrypto = false"
      v-model:cryptoForm="crypto"
      :receivedCryptoForm="crypto"
      @updatePayment="(payload) => updateCredentials('crypto', payload)"
    />

    <WalletInfoModal
      ref="walletInfoModal"
      @activate="showActivationModalFromInfo"
    />

    <WalletActivationModal
      ref="activationModal"
      @close="closeActivationModal"
      @confirm="confirmSystemWalletActivation"
    />

    <AffiliateInfoModal
      :isOpen="modalAffiliateInfo"
      @close="modalAffiliateInfo = false"
    />

    <AffiliateRulesModal
      :isOpen="modalAffiliateRules"
      @close="modalAffiliateRules = false"
      @accept="modalAffiliateRules = false"
    />

    <EfipayFormDialog
      :isOpen="modalEfipay"
      @close="modalEfipay = false"
      v-model:efipayForm="efipay"
      :receivedEfipay="efipay"
      @updatePayment="updateCredentials('efipay')"
    />

    <ZettFormDialog
      :isOpen="modalZett"
      @close="modalZett = false"
      v-model:zettForm="zett"
      :receivedZett="zett"
      @updatePayment="updateCredentials('zett')"
    />

    <Paggo365FormDialog
      :isOpen="modalPaggo365"
      @close="modalPaggo365 = false"
      v-model:paggo365Form="paggo365"
      :receivedPaggo365="paggo365"
      @updatePayment="(payload) => updateCredentials('paggo365', payload)"
    />

    <TwoFAModal
      :isOpen="modal2FA"
      :loading="verifying2FA"
      @close="modal2FA = false"
      @verify="verify2FACode"
      @resend="send2FACode"
    />

    <TotpSetupModal
      :isOpen="modalTotp"
      :loading="verifyingTotp"
      :secret="totpSecret"
      :otpauthUrl="totpOtpauthUrl"
      @close="modalTotp = false"
      @confirm="confirmTotp"
      @copied="
        $toast.add({
          severity: 'success',
          summary: 'Copiado',
          detail: 'Chave copiada.',
          life: 2000,
        })
      "
    />

    <LogoutNotificationModal
      :isOpen="modal2FASuccess"
      @confirm="executeFinalLogout"
    />

    <!-- MODAL: Confirmar senha para desativar 2FA -->
    <div v-if="modalDisable2FA" class="custom-modal-overlay" style="z-index: 9999">
      <div class="custom-modal-dialog" style="max-width: 420px">
        <div class="custom-modal-content" style="padding: 24px">
          <div class="custom-modal-header pb-2 mb-3">
            <h5 class="modal-title mb-0" style="color: #b91c1c">
              <i class="material-icons" style="font-size: 20px; vertical-align: middle; margin-right: 4px">no_encryption</i>
              Desativar Autenticação de Dois Fatores
            </h5>
            <button type="button" class="btn-close" @click="modalDisable2FA = false; disable2FAPassword = ''">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <p class="text-sm text-secondary mb-3">
            Para confirmar, insira sua senha atual. Após desativar o 2FA, o seu login deixará de exigir o código pelo WhatsApp.
          </p>
          <div class="input-group input-group-outline m-0 d-flex flex-column mb-3">
            <label class="input-label">
              <span class="text-xs text-uppercase text-body font-weight-bolder">Senha atual</span>
              <input
                v-model="disable2FAPassword"
                type="password"
                class="form-control default-bordered-input"
                placeholder="Digite sua senha"
                @keyup.enter="confirmDisable2FA"
                autofocus
              />
            </label>
          </div>
          <div class="d-flex gap-2 justify-content-end mt-2">
            <button
              type="button"
              class="btn btn-secondary mb-0"
              @click="modalDisable2FA = false; disable2FAPassword = ''"
            >Cancelar</button>
            <button
              type="button"
              class="btn mb-0"
              style="background: #fee2e2; border: 1px solid #ef4444; color: #b91c1c"
              :disabled="!disable2FAPassword || disabling2FA"
              @click="confirmDisable2FA"
            >
              <span v-if="disabling2FA"><i class="material-icons" style="font-size:16px;vertical-align:middle">sync</i> Desativando...</span>
              <span v-else><i class="material-icons" style="font-size:16px;vertical-align:middle">no_encryption</i> Desativar 2FA</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <Loading v-if="loading" />

    <div
      v-if="modalDomainDnsGuide"
      class="px-modal-backdrop"
      @click.self="closeDomainDnsGuideModal"
    >
      <div class="px-modal domain-dns-guide-modal" role="dialog" aria-modal="true">
        <div class="px-modal-header">
          <h6 class="mb-0">Configure o DNS na Cloudflare</h6>
          <button
            type="button"
            class="px-modal-close"
            @click="closeDomainDnsGuideModal"
            aria-label="Fechar"
          >
            <i class="material-icons">close</i>
          </button>
        </div>
        <div class="px-modal-body">
          <p class="text-sm text-secondary mb-3">
            Domínio <strong>{{ domainDnsGuideDomain }}</strong> salvo.
            Agora abra a <strong>Cloudflare</strong> (ou a registradora do domínio) e crie estes registros
            para o site funcionar na Rifa365:
          </p>
          <div class="table-responsive mb-3">
            <table class="table table-sm align-items-center mb-0 domain-dns-table">
              <thead>
                <tr>
                  <th class="text-xxs text-uppercase">Tipo</th>
                  <th class="text-xxs text-uppercase">Nome</th>
                  <th class="text-xxs text-uppercase">Valor</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in domainDnsRecords" :key="'guide-' + row.type + row.name">
                  <td><span class="badge badge-sm bg-gradient-dark">{{ row.type }}</span></td>
                  <td class="text-xs font-weight-bold">{{ row.name }}</td>
                  <td class="text-xs"><code>{{ row.value }}</code></td>
                  <td class="text-end">
                    <button
                      type="button"
                      class="btn btn-link btn-sm p-0 text-xxs"
                      @click="copyDnsValue(row.value)"
                    >
                      copiar
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <ol class="text-xs text-secondary ps-3 mb-3">
            <li>Cloudflare → domínio → DNS → Add record.</li>
            <li>Crie o registro <strong>A</strong> (@) e o <strong>CNAME</strong> (www).</li>
            <li>Proxy da Cloudflare: pode deixar DNS only (cinza) se der conflito de SSL.</li>
            <li>Aguarde alguns minutos até 2 horas para propagar.</li>
          </ol>
          <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-sm bg-gradient-primary mb-0" @click="closeDomainDnsGuideModal">
              Entendi
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="modalDomainTutorial"
      class="px-modal-backdrop"
      @click.self="closeDomainTutorialModal"
    >
      <div class="px-modal domain-video-modal" role="dialog" aria-modal="true">
        <div class="px-modal-header">
          <h6 class="mb-0">Tutorial: apontamento DNS</h6>
          <button
            type="button"
            class="px-modal-close"
            @click="closeDomainTutorialModal"
            aria-label="Fechar"
          >
            <i class="material-icons">close</i>
          </button>
        </div>
        <div class="px-modal-body">
          <div v-if="domainTutorialEmbedUrl" class="domain-video-frame">
            <iframe
              :src="domainTutorialEmbedUrl"
              title="Tutorial domínio personalizado"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <div v-else class="domain-video-placeholder text-center py-4">
            <i class="material-icons text-secondary mb-2" style="font-size: 48px">ondemand_video</i>
            <p class="text-sm text-secondary mb-0">
              O vídeo tutorial ainda será publicado aqui. Enquanto isso, use a tabela de apontamentos DNS acima.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import DefaultInput from "../../components/DefaultInput.vue";
import PhoneInput from "../../components/PhoneInput.vue";
import PaggueFormDialog from "./components/PaggueFormDialog.vue";
import Pay2mFormDialog from "./components/Pay2mFormDialog.vue";
import FluxsisFormDialog from "./components/FluxsisFormDialog.vue";
import ProfilePictureInput from "@/components/ProfilePictureInput.vue";
import PixFormDialog from "./components/PixFormDialog.vue";
import CryptoFormDialog from "./components/CryptoFormDialog.vue";
import Paggo365FormDialog from "./components/Paggo365FormDialog.vue";
import EfipayFormDialog from "./components/EfipayFormDialog.vue";
import ZettFormDialog from "./components/ZettFormDialog.vue";
import ImageInput from "@/components/ImageInput.vue";
import WalletInfoModal from "@/components/WalletInfoModal.vue";
import WalletActivationModal from "@/components/WalletActivationModal.vue";
import AffiliateInfoModal from "./components/AffiliateInfoModal.vue";
import AffiliateRulesModal from "./components/AffiliateRulesModal.vue";
import TwoFAModal from "./components/TwoFAModal.vue";
import TotpSetupModal from "./components/TotpSetupModal.vue";
import LogoutNotificationModal from "./components/LogoutNotificationModal.vue";
import LoggingMixin from "@/mixins/LoggingMixin.js";

import UsersHttp from "@/http/UsersHttp.js";
import PaymentHttp from "@/http/PaymentHttp.js";
import iconMeta from "@/assets/img/integrations/meta.svg";
import iconGoogle from "@/assets/img/integrations/google.svg";
import iconTiktok from "@/assets/img/integrations/tiktok.svg";
import iconKwai from "@/assets/img/integrations/kwai.svg";

export default {
  name: "profile-overview",
  mixins: [LoggingMixin],
  data() {
    return {
      defaultProfileImage: require("@/assets/img/default-user-icon.jpg"),
      page: "account",
      showMenu: false,
      loading: true,
      savingDomain: false,
      domainForm: "",
      themePrimary: "",
      themeAccent: "",
      savingTheme: false,
      modalDomainTutorial: false,
      modalDomainDnsGuide: false,
      domainDnsGuideDomain: "",
      // Cole o link do YouTube quando o vídeo estiver pronto (watch ou youtu.be)
      domainTutorialUrl: "",
      domainDnsRecords: [
        { type: "A", name: "@", value: "216.150.1.1", hint: "Raiz do domínio (sem www)" },
        { type: "CNAME", name: "www", value: "cname.vercel-dns.com", hint: "Subdomínio www" },
      ],
      modalPixManual: false,
      modalCrypto: false,
      modalPixPay2m: false,
      modalPaggue: false,
      modalFluxsis: false,
      modalEfipay: false,
      modalZett: false,
      modalPaggo365: false,
      modalAffiliateInfo: false,
      modalAffiliateRules: false,
      paymentMethods: [],
      modal2FA: false,
      modal2FASuccess: false,
      modalDisable2FA: false,
      disable2FAPassword: "",
      disabling2FA: false,
      deleteAccountConfirmation: "",
      deleteAccountPassword: "",
      deletingAccount: false,
      twoFACode: "",
      verifying2FA: false,
      sending2FA: false,
      modalTotp: false,
      sendingTotp: false,
      verifyingTotp: false,
      totpSecret: "",
      totpOtpauthUrl: "",
      savingPixel: false,
      pixelModal: {
        open: false,
        key: "",
        pixel_fb: "",
        meta_capi_token: "",
        gtag: "",
        pixel_tiktok: "",
      },
      pixelIntegrations: [
        {
          key: "meta",
          name: "Pixel da Meta",
          description:
            "Meça e otimize campanhas no Facebook e Instagram com eventos de conversão.",
          icon: iconMeta,
          soon: false,
        },
        {
          key: "google",
          name: "Google Ads",
          description:
            "Acompanhe conversões e remarketing com o gtag do Google Ads.",
          icon: iconGoogle,
          soon: false,
        },
        {
          key: "tiktok",
          name: "TikTok Pixel",
          description:
            "Envie eventos de funil para otimizar anúncios no TikTok Ads.",
          icon: iconTiktok,
          soon: false,
        },
        {
          key: "kwai",
          name: "Kwai Pixel",
          description: "Integração com o Kwai Ads em breve nesta tela.",
          icon: iconKwai,
          soon: true,
        },
      ],
      user: {
        full_name: "",
        email: "",
        phone: "",
        whatsapp: "",
        whatsapp_group_popup_enabled: false,
        telegram: "",
        instagram: "",
        tiktok: "",
        youtube: "",
        pixel_fb: "",
        gtag: "",
        pixel_tiktok: "",
        meta_capi_token: "",
        logo: "",
        profile: "",
        domain: "",
      },
      manual: {
        pix_type: "",
        pix: "",
        name: "",
      },
      crypto: {
        asset: "USDT",
        network: "TRC20",
        address: "",
        label: "",
      },
      globalSettings: {
        affiliate_percent_system_wallet: 10,
        affiliate_percent_other_method: 30,
        affiliate_percent_first_fee: 50,
        affiliate_plan_fee_base: 97,
        remarketing_fee_base: 47,
      },
      pay2m: {
        client_id: "",
        client_secret: "",
      },
      paggue: {
        client_key: "",
        client_secret: "",
      },
      onz: {
        client_id: "",
        client_secret: "",
        pix: "",
        pass_fee: false,
      },
      efipay: {
        client_id: "",
        client_secret: "",
        pix_key: "",
        certificate: null,
        pass_fee: false,
      },
      zett: {
        client_id: "",
        client_secret: "",
        pass_fee: false,
      },
      paggo365: {
        public_key: "",
        secret_key: "",
      },
    };
  },
  components: {
    Loading,
    DefaultInput,
    PhoneInput,
    PaggueFormDialog,
    ProfilePictureInput,
    Pay2mFormDialog,
    PixFormDialog,
    CryptoFormDialog,
    EfipayFormDialog,
    ZettFormDialog,
    Paggo365FormDialog,
    TwoFAModal,
    TotpSetupModal,
    LogoutNotificationModal,
    ImageInput,
    FluxsisFormDialog,
    WalletInfoModal,
    WalletActivationModal,
    AffiliateInfoModal,
    AffiliateRulesModal,
  },

  async mounted() {
    await this.init();
    if (this.$route.query.tab) {
      this.page = this.$route.query.tab;
    }
  },

  watch: {
    $route(to) {
      if (to.query.tab) {
        this.page = to.query.tab;
      }
    },
    page(newVal) {
      if (newVal === 'affiliate') {
        if (!localStorage.getItem('seen_affiliate_modal')) {
          this.modalAffiliateInfo = true;
          localStorage.setItem('seen_affiliate_modal', 'true');
        }
      }
    },
    "$store.state.isDarkMode": function () {
      if (this.$store.state.isDarkMode) {
        document.querySelectorAll(".input-default").forEach((el) => {
          el.classList.add("dark-mode-input");
        });
      } else {
        document.querySelectorAll(".input-default").forEach((el) => {
          el.classList.remove("dark-mode-input");
        });
      }
    },
  },

  methods: {
    showWalletInfo() {
      this.$refs.walletInfoModal.show();
    },
    showActivationModalFromInfo() {
      this.$refs.activationModal.show();
    },
    async toggleAffiliateStatus() {
      this.loading = true;
      try {
        const response = await UsersHttp.toggleAffiliate();
        this.user.is_affiliate = response.data.is_affiliate;
        this.$store.commit('setUser', this.user)
        window.dispatchEvent(new Event("user-updated"));
        this.$toast.add({
          severity: "success",
          summary: "Sucesso!",
          detail: "Status de afiliado atualizado.",
          life: 3000,
        });
        if (this.user.is_affiliate) {
          this.modalAffiliateRules = true;
        }
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Erro!",
          detail: error.response?.data?.error || "Erro ao atualizar status.",
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
    copyAffiliateLink() {
      navigator.clipboard.writeText(this.affiliateLink);
      this.$toast.add({
        severity: "success",
        summary: "Copiado!",
        detail: "Link de afiliado copiado para a área de transferência.",
        life: 3000,
      });
    },
    activateSystemWallet() {
      this.$refs.activationModal.show();
    },
    closeActivationModal() {
      // do nothing or handle close
    },
    async confirmSystemWalletActivation() {
      this.loading = true;
      try {
        // Update user object locally and send to backend
        let updatedUser = { ...this.user };
        updatedUser.system_wallet = true;

        const response = await UsersHttp.updateProfile(updatedUser);
        this.user = response.data;

        this.$store.commit('setUser', this.user)
        
        this.$log.log("CONFIGURAÇÕES", "AÇÃO", `Usuário "${this.user.full_name}" ativou a Carteira do Sistema`);

        this.$toast.add({
          severity: "success",
          summary: "Sucesso!",
          detail: "Carteira do Sistema ativada com sucesso.",
          life: 3000,
        });
      } catch (error) {
        console.error(error);
        this.$toast.add({
          severity: "error",
          summary: "Erro!",
          detail: "Erro ao ativar carteira.",
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
    async init() {
      this.loading = true;
      this.checkTabQuery();
      let payment_methods = this.getPaymentMethods();
      let user_data = this.getUserData();

      Promise.all([payment_methods, user_data]).then(() => {
        this.loading = false;
      });
    },
    async getUserData() {
      try {
        const response = await UsersHttp.getProfile();
        this.user = response.data;
        this.domainForm = this.user.domain || "";
        this.themePrimary = this.user.theme_primary_color || "";
        this.themeAccent = this.user.theme_accent_color || "";

        if (this.user.role === 'MASTER') {
          const settingsRes = await UsersHttp.getGlobalSettings();
          if (settingsRes.data) {
            this.globalSettings = {
              affiliate_percent_system_wallet: settingsRes.data.affiliate_percent_system_wallet,
              affiliate_percent_other_method: settingsRes.data.affiliate_percent_other_method,
              affiliate_percent_first_fee: settingsRes.data.affiliate_percent_first_fee ?? 50,
              affiliate_plan_fee_base: settingsRes.data.affiliate_plan_fee_base ?? 97,
              remarketing_fee_base: settingsRes.data.remarketing_fee_base ?? 47,
            };
          }
        }
      } catch (error) {
        console.error(error);
        this.$toast.add({
          severity: "error",
          summary: "Ops...",
          detail:
            "Houve um erro ao buscar os dados de sua conta. Mas não se preocupe, tente novamente em instantes!",
          life: 3000,
        });
      }
    },
    checkTabQuery() {
      if (this.$route.query.tab) {
        this.page = this.$route.query.tab;
      }
    },

    async getPaymentMethods() {
      try {
        const response = await PaymentHttp.getPaymentProviders();
        this.paymentMethods = Array.isArray(response.data) ? response.data : [];

        for (const e of this.paymentMethods) {
          const parsedData = JSON.parse(e.data);
          const methodName = e.name.toLowerCase();

          // Garantir que os objetos tenham sempre valores válidos
          if (methodName === "manual") {
            this[methodName] = {
              pix_type: parsedData?.pix_type || "",
              pix: parsedData?.pix || "",
              name: parsedData?.name || "",
            };
          } else if (methodName === "crypto") {
            this[methodName] = {
              asset: parsedData?.asset || "USDT",
              network: parsedData?.network || "TRC20",
              address: parsedData?.address || "",
              label: parsedData?.label || "",
            };
          } else if (methodName === "pay2m") {
            this[methodName] = {
              client_id: parsedData?.client_id || "",
              client_secret: parsedData?.client_secret || "",
            };
          } else if (methodName === "paggue") {
            this[methodName] = {
              client_key: parsedData?.client_key || "",
              client_secret: parsedData?.client_secret || "",
            };
          } else if (methodName === "onz") {
            this[methodName] = {
              client_id: parsedData?.client_id || "",
              client_secret: parsedData?.client_secret || "",
              pix: parsedData?.pix || "",
              pass_fee: parsedData?.pass_fee || false,
            };
          } else if (methodName === "efipay") {
            this[methodName] = {
              client_id: parsedData?.client_id || "",
              client_secret: parsedData?.client_secret || "",
              pix_key: parsedData?.pix_key || "",
              certificate: parsedData?.certificate || null,
              pass_fee: parsedData?.pass_fee || false,
            };
          } else if (methodName === "zett") {
            this[methodName] = {
              client_id: parsedData?.client_id || "",
              client_secret: parsedData?.client_secret || "",
              pass_fee: parsedData?.pass_fee || false,
            };
          } else if (methodName === "paggo365") {
            this[methodName] = {
              public_key: parsedData?.public_key || "",
              secret_key: parsedData?.secret_key || "",
              webhook_secret: parsedData?.webhook_secret || "",
            };
          }

          // Definir pass_fee apenas se não foi definido acima
          if (methodName !== "onz" && methodName !== "efipay" && methodName !== "zett" && methodName !== "paggo365") {
            this[methodName].pass_fee = e.pass_fee;
          }
        }
      } catch (error) {
        console.error(error);
        this.$toast.add({
          severity: "error",
          summary: "Ops...",
          detail: "Ocorreu um erro ao buscar seus métodos de pagamento.",
          life: 3000,
        });
      }
    },
    async updateCredentials(name, payloadOverride = null) {
      try {
        this.loading = true;
        if (payloadOverride && typeof payloadOverride === "object") {
          this[name] = { ...this[name], ...payloadOverride };
        }
        let pass_fee = this[name].pass_fee ? true : false;

        // Para EFIPAY, fazer upload do P12 primeiro
        if (name === "efipay" && this[name].certificate_file) {
          // Ler arquivo como base64
          const file = this[name].certificate_file;
          const reader = new FileReader();

          const fileBase64 = await new Promise((resolve, reject) => {
            reader.onload = () => {
              const base64 = reader.result.split(",")[1];
              resolve(base64);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
          });

          // Upload para API
          try {
            const uploadResponse = await PaymentHttp.uploadCertificate({
              file: fileBase64,
            });

            this[name].certificate = {
              p12_path: uploadResponse.data.path,
              filename: uploadResponse.data.filename,
              updated_at: new Date().toISOString(),
            };
            delete this[name].certificate_file;
          } catch (uploadError) {
            console.error("Erro ao fazer upload do certificado:", uploadError);
            this.$toast.add({
              severity: "error",
              summary: "Erro no upload",
              detail: "Não foi possível fazer upload do certificado P12.",
              life: 3000,
            });
            this.loading = false;
            return;
          }
        }

        delete this[name].pass_fee;
        let data = {
          data: JSON.stringify(this[name]),
          pass_fee,
        };

        await PaymentHttp.updatePaymentProvider(name, data);

        const providerLabels = {
          manual: "PIX Manual",
          crypto: "Crypto",
          paggo365: "Paggo365",
          pay2m: "Pay2m",
          paggue: "Paggue",
          efipay: "EfiPay",
          fluxsis: "Fluxsis",
          zett: "ZettPay",
        };
        this.$log.logPaymentProviderConfigured(providerLabels[name] || name);

        this.getPaymentMethods();
        this.modalPixManual = false;
        this.modalCrypto = false;
        this.modalPaggo365 = false;
        this.modalPixPay2m = false;
        this.modalEfipay = false;
        this.modalZett = false;
        this.loading = false;
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Ops...",
          detail: "Não foi possível alterar seus dados de recebimento.",
          life: 3000,
        });
        console.error(error);
        this.loading = false;
      }
    },
    async saveGlobalSettings() {
      this.loading = true;
      try {
        await UsersHttp.updateGlobalSettings({
          affiliate_percent_system_wallet: parseFloat(this.globalSettings.affiliate_percent_system_wallet),
          affiliate_percent_other_method: parseFloat(this.globalSettings.affiliate_percent_other_method),
          affiliate_percent_first_fee: parseFloat(this.globalSettings.affiliate_percent_first_fee),
          affiliate_plan_fee_base: parseFloat(this.globalSettings.affiliate_plan_fee_base),
          remarketing_fee_base: parseFloat(this.globalSettings.remarketing_fee_base),
        });
        this.$log.log("CONFIGURAÇÕES", "AÇÃO", `Usuário atualizou afiliados plataforma — 1ª taxa: ${this.globalSettings.affiliate_percent_first_fee}%, base plano: ${this.globalSettings.affiliate_plan_fee_base}, remarketing: ${this.globalSettings.remarketing_fee_base}`);
        this.$toast.add({
          severity: "success",
          summary: "Sucesso!",
          detail: "Configurações globais salvas com sucesso.",
          life: 3000,
        });
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Erro!",
          detail: "Erro ao salvar as configurações globais.",
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
    openDomainTutorialModal() {
      this.modalDomainTutorial = true;
    },
    closeDomainTutorialModal() {
      this.modalDomainTutorial = false;
    },
    async copyDnsValue(value) {
      try {
        await navigator.clipboard.writeText(value);
        this.$toast.add({
          severity: "success",
          summary: "Copiado",
          detail: "Valor DNS copiado.",
          life: 2000,
        });
      } catch (e) {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Não foi possível copiar.",
          life: 2500,
        });
      }
    },
    async saveDomain() {
      this.savingDomain = true;
      try {
        const response = await UsersHttp.updateDomain(this.domainForm || null);
        const domain = response.data?.domain ?? response.data?.user?.domain ?? null;
        this.user = {
          ...this.user,
          domain,
          domain_ready: response.data?.domain_ready ?? response.data?.user?.domain_ready ?? this.user.domain_ready,
        };
        this.domainForm = domain || "";
        const storeUser = this.$store.getters.user;
        if (storeUser) {
          this.$store.commit("setUser", {
            ...storeUser,
            domain,
            domain_ready: this.user.domain_ready,
          });
        }

        const vercel = response.data?.vercel || {};
        const dnsFromApi = Array.isArray(vercel.dns_records) ? vercel.dns_records : [];
        if (dnsFromApi.length) {
          this.domainDnsRecords = dnsFromApi.map((row) => ({
            type: row.type,
            name: row.name,
            value: row.value,
            hint: row.hint || "",
          }));
        }

        this.$toast.add({
          severity: "success",
          summary: "Domínio personalizado salvo",
          detail: response.data?.message || "Domínio personalizado atualizado com sucesso.",
          life: 4000,
        });

        if (domain) {
          this.domainDnsGuideDomain = domain;
          this.modalDomainDnsGuide = true;
        }
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: error?.error || error?.message || "Não foi possível salvar o domínio personalizado.",
          life: 4000,
        });
      } finally {
        this.savingDomain = false;
      }
    },
    closeDomainDnsGuideModal() {
      this.modalDomainDnsGuide = false;
    },
    async clearDomain() {
      this.domainForm = "";
      await this.saveDomain();
    },
    onThemePrimaryPick(e) {
      this.themePrimary = e.target.value;
    },
    onThemeAccentPick(e) {
      this.themeAccent = e.target.value;
    },
    async saveTheme() {
      const hexOk = (v) => !v || /^#[0-9A-Fa-f]{6}$/.test(v);
      if (!hexOk(this.themePrimary) || !hexOk(this.themeAccent)) {
        this.$toast.add({
          severity: "warn",
          summary: "Atenção",
          detail: "Use cores no formato #RRGGBB (ex: #5900b2).",
          life: 4000,
        });
        return;
      }
      try {
        this.savingTheme = true;
        const response = await UsersHttp.updateTheme(
          this.themePrimary || null,
          this.themeAccent || null
        );
        const primary =
          response.data?.theme_primary_color ??
          response.data?.user?.theme_primary_color ??
          null;
        const accent =
          response.data?.theme_accent_color ??
          response.data?.user?.theme_accent_color ??
          null;
        this.themePrimary = primary || "";
        this.themeAccent = accent || "";
        this.user = {
          ...this.user,
          theme_primary_color: primary,
          theme_accent_color: accent,
        };
        const storeUser = this.$store.state.user;
        if (storeUser) {
          this.$store.commit("setUser", {
            ...storeUser,
            theme_primary_color: primary,
            theme_accent_color: accent,
          });
        }
        this.$toast.add({
          severity: "success",
          summary: "Sucesso",
          detail: "Cores da marca salvas.",
          life: 3000,
        });
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Ops...",
          detail:
            error?.error ||
            error?.message ||
            "Não foi possível salvar as cores.",
          life: 4000,
        });
      } finally {
        this.savingTheme = false;
      }
    },
    async updateUserData() {
      try {
        this.loading = true;
        let response = await UsersHttp.updateProfile(this.user);
        if (response.data.error) {
          this.$toast.error(response.data.error);
          return;
        }
        this.$log.log("CONFIGURAÇÕES", "AÇÃO", `Usuário atualizou os dados do perfil (nome: "${this.user.full_name}", e-mail: ${this.user.email})`);
        this.getUserData();
        this.loading = false;
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Ops...",
          detail:
            "Houve um erro ao atualizar seus dados. Tente novamente em intantes.",
          life: 3000,
        });
        this.loading = false;
      }
    },
    isPixelConfigured(key) {
      if (key === "meta") return !!(this.user.pixel_fb && String(this.user.pixel_fb).trim());
      if (key === "google") return !!(this.user.gtag && String(this.user.gtag).trim());
      if (key === "tiktok")
        return !!(this.user.pixel_tiktok && String(this.user.pixel_tiktok).trim());
      return false;
    },
    openPixelModal(key) {
      this.pixelModal = {
        open: true,
        key,
        pixel_fb: this.user.pixel_fb || "",
        meta_capi_token: this.user.meta_capi_token || "",
        gtag: this.user.gtag || "",
        pixel_tiktok: this.user.pixel_tiktok || "",
      };
    },
    closePixelModal() {
      this.pixelModal.open = false;
    },
    async savePixelModal() {
      try {
        this.savingPixel = true;
        if (this.pixelModal.key === "meta") {
          this.user.pixel_fb = (this.pixelModal.pixel_fb || "").trim();
          this.user.meta_capi_token = (this.pixelModal.meta_capi_token || "").trim();
        } else if (this.pixelModal.key === "google") {
          this.user.gtag = (this.pixelModal.gtag || "").trim();
        } else if (this.pixelModal.key === "tiktok") {
          this.user.pixel_tiktok = (this.pixelModal.pixel_tiktok || "").trim();
        }
        await this.updateUserData();
        this.closePixelModal();
        this.$toast.add({
          severity: "success",
          summary: "Salvo",
          detail: "Integração de pixel atualizada.",
          life: 2500,
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.savingPixel = false;
      }
    },
    async setDefaultPaymentProvider(name) {
      const paymentMethod = this.paymentMethods.find(
        (item) => item.name == name
      );

      if (paymentMethod != null) {
        this.user.default_provider = paymentMethod.id;
        await this.updateUserData();
      }
    },
    updateUserImage(newImage) {
      this.user.profile = newImage;
    },
    updateLogoImage(newImage) {
      this.user.logo = newImage;
    },
    async send2FACode() {
      try {
        this.sending2FA = true;
        await UsersHttp.send2FACode();
        this.modal2FA = true;
        this.$toast.add({
          severity: "success",
          summary: "Sucesso",
          detail: "Código enviado para seu WhatsApp!",
          life: 3000,
        });
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: error.response?.data?.error || "Erro ao enviar código.",
          life: 3000,
        });
      } finally {
        this.sending2FA = false;
      }
    },
    async verify2FACode(code) {
      const codeToVerify = code || this.twoFACode;
      if (!codeToVerify || codeToVerify.length < 6) {
        this.$toast.add({
          severity: "warn",
          summary: "Aviso",
          detail: "Insira o código de 6 dígitos.",
          life: 3000,
        });
        return;
      }
      try {
        this.verifying2FA = true;
        const response = await UsersHttp.verify2FACode(codeToVerify);
        this.user.two_fa_enabled = response.data.two_fa_enabled;
        this.user.two_fa_method = response.data.two_fa_method || "whatsapp_email";
        this.modal2FA = false;
        this.twoFACode = "";
        
        // Abre o modal de sucesso com aviso de logout
        this.modal2FASuccess = true;
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: error.response?.data?.error || "Código inválido.",
          life: 3000,
        });
      } finally {
        this.verifying2FA = false;
      }
    },
    async setupTotp() {
      try {
        this.sendingTotp = true;
        const response = await UsersHttp.setupTotp();
        this.totpSecret = response.data.secret || "";
        this.totpOtpauthUrl = response.data.otpauth_url || "";
        this.modalTotp = true;
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: error.response?.data?.error || "Erro ao gerar autenticador.",
          life: 3000,
        });
      } finally {
        this.sendingTotp = false;
      }
    },
    async confirmTotp(code) {
      if (!code || code.length < 6) {
        this.$toast.add({
          severity: "warn",
          summary: "Aviso",
          detail: "Insira o código de 6 dígitos.",
          life: 3000,
        });
        return;
      }
      try {
        this.verifyingTotp = true;
        const response = await UsersHttp.confirmTotp(code);
        this.user.two_fa_enabled = response.data.two_fa_enabled;
        this.user.two_fa_method = response.data.two_fa_method || "totp";
        this.modalTotp = false;
        this.totpSecret = "";
        this.totpOtpauthUrl = "";
        this.modal2FASuccess = true;
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: error.response?.data?.error || "Código inválido.",
          life: 3000,
        });
      } finally {
        this.verifyingTotp = false;
      }
    },
    async executeFinalLogout() {
      try {
        await UsersHttp.logout();
      } catch (e) {
        console.error("Erro ao realizar logout no servidor:", e);
      }
      
      this.$store.commit('logout');
    },
    async disable2FA() {
      // Abre o modal de confirmação de senha em vez de usar confirm()
      this.disable2FAPassword = "";
      this.modalDisable2FA = true;
    },
    async confirmDisable2FA() {
      if (!this.disable2FAPassword) return;
      try {
        this.disabling2FA = true;
        const response = await UsersHttp.disable2FA(this.disable2FAPassword);
        this.user.two_fa_enabled = response.data.two_fa_enabled;
        this.user.two_fa_method = null;
        this.modalDisable2FA = false;
        this.disable2FAPassword = "";
        this.$toast.add({
          severity: "success",
          summary: "Sucesso",
          detail: "2FA desativado com sucesso.",
          life: 3000,
        });
      } catch (error) {
        const status = error?.response?.status || error?.status;
        const msg = error?.response?.data?.error || error?.error || "";

        if (status === 401 || msg === "Senha incorreta") {
          this.$toast.add({
            severity: "error",
            summary: "Senha incorreta",
            detail: "A senha informada está incorreta. Tente novamente.",
            life: 4000,
          });
          return;
        }
        if (status === 429) {
          this.$toast.add({
            severity: "warn",
            summary: "Muitas tentativas.",
            detail: "Aguarde 1 minuto antes de tentar novamente.",
            life: 6000,
          });
          this.modalDisable2FA = false;
          return;
        }
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: msg || "Erro ao desativar 2FA.",
          life: 3000,
        });
      } finally {
        this.disabling2FA = false;
      }
    },
    async confirmDeleteAccount() {
      if (!this.canDeleteAccount || this.deletingAccount) return;
      if (
        !confirm(
          "Tem certeza? Esta ação anonimiza seus dados e bloqueia o acesso de forma permanente."
        )
      ) {
        return;
      }
      try {
        this.deletingAccount = true;
        await UsersHttp.deleteAccount(
          this.deleteAccountPassword,
          this.deleteAccountConfirmation.trim()
        );
        this.$toast.add({
          severity: "success",
          summary: "Conta excluída",
          detail: "Seus dados foram anonimizados. Encerrando sessão...",
          life: 3000,
        });
        this.deleteAccountConfirmation = "";
        this.deleteAccountPassword = "";
        try {
          await UsersHttp.logout();
        } catch (e) {
          console.error(e);
        }
        this.$store.commit("logout");
      } catch (error) {
        const msg =
          error?.response?.data?.error ||
          error?.error ||
          "Não foi possível excluir a conta.";
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: msg,
          life: 4000,
        });
      } finally {
        this.deletingAccount = false;
      }
    },
  },
  computed: {
    canDeleteAccount() {
      return (
        (this.deleteAccountConfirmation || "").trim() ===
          "Autorizo excluir minha conta" &&
        !!(this.deleteAccountPassword || "").trim()
      );
    },
    domainTutorialEmbedUrl() {
      const raw = (this.domainTutorialUrl || "").trim();
      if (!raw) return "";
      try {
        const url = new URL(raw);
        if (url.hostname.includes("youtu.be")) {
          const id = url.pathname.replace("/", "");
          return id ? `https://www.youtube.com/embed/${id}` : "";
        }
        if (url.hostname.includes("youtube.com")) {
          const id = url.searchParams.get("v");
          if (id) return `https://www.youtube.com/embed/${id}`;
          const parts = url.pathname.split("/").filter(Boolean);
          if (parts[0] === "embed" && parts[1]) {
            return `https://www.youtube.com/embed/${parts[1]}`;
          }
          if (parts[0] === "shorts" && parts[1]) {
            return `https://www.youtube.com/embed/${parts[1]}`;
          }
        }
      } catch (e) {
        return "";
      }
      return "";
    },
    affiliateLink() {
      return `https://app.rifa365.digital/sign-up?ref=${this.user.id}`;
    },
    isDefaultProvider() {
      return (paymentMethodName) => {
        const methods = Array.isArray(this.paymentMethods)
          ? this.paymentMethods
          : [];
        const paymentMethod = methods.find(
          (method) => method.name === paymentMethodName
        );

        return paymentMethod
          ? this.user.default_provider === paymentMethod.id
          : false;
      };
    },
    isPageActive() {
      return (name) => {
        return name === this.page;
      };
    },
    pixelModalTitle() {
      const map = {
        meta: "Pixel da Meta",
        google: "Google Ads",
        tiktok: "TikTok Pixel",
      };
      return map[this.pixelModal.key] || "Configurar pixel";
    },
    showDefaultPaymentTypeButton() {
      return (paymentMethodName) => {
        const methods = Array.isArray(this.paymentMethods)
          ? this.paymentMethods
          : [];
        const paymentMethod = methods.find(
          (method) => method.name === paymentMethodName
        );

        if (!paymentMethod || !paymentMethod.data) {
          return false;
        }

        try {
          const parsedData = JSON.parse(paymentMethod.data);
          return (
            typeof parsedData === "object" &&
            !Array.isArray(parsedData) &&
            Object.keys(parsedData).length > 0
          );
        } catch (error) {
          console.error(error);
          return false;
        }
      };
    },
  },
};
</script>

<style scoped lang="scss">
.input-default {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
}

.dark-mode-input {
  background-color: #1a2035 !important;
  border: 1px solid #10131f !important;
  color: #fff;
}

.active {
  background-color: #f8f9fa;
  color: #e91e63 !important;
  border-radius: 10px;
  font-weight: bold;
}

.card-payments {
  width: 100%;
  border: 1px solid #d2d6da;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
}

.card-payments .payment-logo {
  width: 25px;
}

.card-payments span {
  font-size: 20px;
  font-weight: bold;
  font-size: 20px;
  font-weight: 500;
  margin-right: 15px;
}
.card-payments p {
  font-size: 14px;
  font-weight: 400;
  margin-top: 10px;
  margin-bottom: -4px;
}
.btn-settings {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  float: right;
  border: 1px solid #d2d6da;
  background-color: transparent;
  border-radius: 5px;
  font-size: 11pt;
  padding: 5px 10px;
}
.size-4 {
  width: 1rem;
  height: 1rem;
}

.badge-green {
  display: inline-flex;
  align-items: center;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity));
  padding: 0.1rem 0.3rem;
  text-transform: capitalize;
  font-size: 0.75rem !important;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity));
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0
    var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0
    calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
    var(--tw-shadow, 0 0 #0000);
  --tw-ring-inset: inset;
  --tw-ring-color: rgb(22 163 74 / 0.2);
  border: 1pt solid #16a34a;
}

.badge-golden {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  border-radius: 0.375rem;
  background-color: rgb(255 246 215 / 1);
  padding: 0.1rem 0.4rem;
  font-size: 0.75rem !important;
  line-height: 1rem;
  font-weight: 600;
  color: rgb(161 116 0);
  border: 1pt solid #a17500;
  box-shadow: 0 0 6px rgba(255, 215, 0, 0.4),
    inset 0 0 4px rgba(255, 215, 0, 0.2);
}

.badge-orange {
  display: inline-flex;
  align-items: center;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(253 236 234 / var(--tw-bg-opacity));
  padding: 0.1rem 0.3rem;
  text-transform: capitalize;
  font-size: 0.75rem !important;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(231 166 41 / var(--tw-text-opacity));
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0
    var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0
    calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
    var(--tw-shadow, 0 0 #0000);
  --tw-ring-inset: inset;
  --tw-ring-color: rgba(226, 144, 50, 0.2);
  border: 1pt solid #e9a72e;
}

/* modal */

.modal-default {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
  background-color: #000000ad;
  z-index: 9999;
}

.account-form {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 25px;
}

.account-form-input {
  width: 100%;
}

.account-img-field {
  width: 180px;
  height: 180px;
  border-radius: 1000px;
}

.social-medias {
  display: grid;
  grid-template-columns: 49% 49%;
  justify-content: space-between;
}

.submit-button {
  background-color: #22c55e;
  color: white;
  display: flex;
  height: 40px;
  min-width: 160px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  line-height: 0;

  .btn-icon {
    font-size: 1.4em;
  }

  &:hover {
    transform: scale(1.04);
    background-color: #169444;
    color: white;
  }
}

.payment-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background-color: #f1f5f9;
  margin-right: 8px;
}

.payment-titles {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.card-payments-row {
  display: flex;
  justify-content: row;
  align-items: center;
}

.button-field {
  width: 100%;
  display: flex;
  justify-content: center;
}

.logo-alert {
  background-color: #2352d3;
  border-radius: 14px;
  padding: 14px;
  margin-bottom: 10px;

  span {
    color: white;
    font-size: 15px;
  }
}

.soon-alert {
  background-color: #2352d3;
  border-radius: 14px;
  padding: 6px 14px;
  margin-bottom: 26px;

  span {
    color: white;
    font-size: 15px;
  }
}

.domain-dns-card {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 12px 14px;
}

.theme-colors-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.theme-color-field {
  min-width: 180px;
}

.theme-color-controls {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.theme-color-picker {
  width: 42px;
  height: 38px;
  padding: 0;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  background: transparent;
  cursor: pointer;
}

.theme-color-hex {
  max-width: 120px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.85rem;
}

.theme-preview {
  color: #fff;
  font-size: 0.8rem;
  font-weight: 600;
  text-align: center;
  padding: 0.65rem 1rem;
  border-radius: 0.65rem;
}

.domain-video-flag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 1px solid #e41b80;
  background: #fff5f9;
  color: #e41b80;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  cursor: pointer;
  line-height: 1;
}

.domain-video-flag .material-icons {
  font-size: 16px;
}

.domain-video-flag:hover {
  background: #e41b80;
  color: #fff;
}

.domain-video-modal {
  max-width: 720px;
  width: calc(100% - 24px);
}

.domain-video-frame {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  border-radius: 10px;
  background: #111;
}

.domain-video-frame iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.domain-dns-table th,
.domain-dns-table td {
  padding: 0.45rem 0.5rem;
  vertical-align: middle;
}

.domain-dns-table code {
  font-size: 0.75rem;
  word-break: break-all;
}

.configure-buttons-field {
  display: flex;
  gap: 12px;
}

@media (max-width: 1000px) {
  .account-form {
    flex-direction: column;
  }

  .configure-buttons-field {
    flex-direction: column;
    gap: 4px;
    margin-top: 8px;
  }

  .card-payments-row,
  .payment-titles {
    flex-direction: column;
  }

  .btn-settings {
    width: 100%;
    margin-top: 10px;
  }

  .badge-field {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    span {
      margin: 0;
    }
  }

  .social-medias {
    display: flex;
    flex-direction: column;
  }
}

.verTaxas {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 10px;
}

.verTaxas a {
  color: #5900b2;
  font-weight: bold;
}

.verTaxas svg {
  color: #5900b2;
  width: 20px;
  height: 20px;
}

/* System Wallet Hightlight Styles */
.system-wallet-card {
  border: 2px solid #5900b2 !important;
  background: linear-gradient(145deg, #f3e5ff 0%, #ffffff 100%);
  box-shadow: 0 4px 15px rgba(89, 0, 178, 0.15) !important;
  transform: scale(1.01);
  transition: all 0.3s ease;
}

.system-wallet-card:hover {
  box-shadow: 0 6px 20px rgba(89, 0, 178, 0.25) !important;
}

.system-wallet-icon {
  background: linear-gradient(45deg, #5900b2, #9c27b0) !important;
  box-shadow: 0 4px 8px rgba(89, 0, 178, 0.3);
}

.system-wallet-title {
  color: #5900b2;
  font-weight: 800 !important;
  font-size: 1.1em;
}

.badge-new {
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  color: white;
  background: #ff007f;
  padding: 2px 6px;
  border-radius: 4px;
  animation: pulse-badge 1.5s infinite;
  display: inline-block;
  margin-left: 5px;
  vertical-align: middle;
}

@keyframes pulse-badge {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 0, 127, 0.7);
  }
  70% {
    transform: scale(1.1);
    box-shadow: 0 0 0 4px rgba(255, 0, 127, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 0, 127, 0);
  }
}

.disabled-payment {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #f5f5f5;
  filter: grayscale(100%);
  position: relative;
}

.disabled-payment::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.disabled-payment button {
  pointer-events: none;
}

/* Modal de confirmação de senha (desativar 2FA) */
.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.custom-modal-dialog {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  max-width: 420px;
  width: 100%;
}

.custom-modal-content {
  padding: 24px;
}

.custom-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}

.btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.badge-diamond-premium {
  background: linear-gradient(135deg, #1a1a1a 0%, #333333 100%);
  color: #ffd700;
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1px;
  border: 1px solid rgba(255, 215, 0, 0.3);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  
  i {
    font-size: 11px;
    filter: drop-shadow(0 0 3px rgba(255, 215, 0, 0.5));
  }
}

/* —— Segurança / 2FA —— */
.sec-shell {
  --sec-purple: #661cb0;
  --sec-pink: #e41b80;
  --sec-ink: #344767;
  --sec-muted: #67748e;
  --sec-line: #e9ecef;
  --sec-soft: #f8f5fc;
}

.sec-delete {
  border-radius: 12px;
  border: 1px solid #fca5a5;
  background: #fff5f5;
}

.sec-delete-label {
  display: block;
  margin-bottom: 6px;
  font-size: 0.75rem;
  font-weight: 700;
  color: #7f1d1d;
}

.sec-delete-input {
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 0.7rem 0.85rem;
  border: 1.5px solid #f87171;
  border-radius: 10px;
  background: #ffffff;
  color: #1e293b;
  font-size: 0.9rem;
  line-height: 1.4;
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.04);
}

.sec-delete-input::placeholder {
  color: #94a3b8;
}

.sec-delete-input:focus {
  outline: none;
  border-color: #dc2626;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.18);
}

.sec-delete-hint {
  margin: 0;
  font-size: 0.75rem;
  color: #64748b;
}

.sec-delete-hint strong {
  color: #b91c1c;
}

.sec-delete-btn {
  border: none;
  border-radius: 10px;
  padding: 0.65rem 1.35rem;
  background: #dc2626;
  color: #ffffff;
  font-size: 0.875rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  box-shadow: 0 8px 18px rgba(220, 38, 38, 0.35);
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;
}

.sec-delete-btn:hover:not(:disabled) {
  background: #b91c1c;
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(185, 28, 28, 0.4);
}

.sec-delete-btn:disabled {
  background: #fca5a5;
  color: #fff;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 0.85;
}

.sec-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.15rem 1.25rem;
  border-radius: 14px;
  border: 1px solid var(--sec-line);
  background: linear-gradient(135deg, #ffffff 0%, var(--sec-soft) 100%);
  margin-bottom: 1rem;
}

.sec-hero--on {
  border-color: rgba(34, 197, 94, 0.35);
  background: linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%);
}

.sec-hero-main {
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  min-width: 0;
  flex: 1;
}

.sec-hero-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  color: #fff;

  .material-icons {
    font-size: 26px;
  }

  &.is-off {
    background: linear-gradient(145deg, var(--sec-purple), #8b3dd4);
    box-shadow: 0 8px 18px rgba(102, 28, 176, 0.22);
  }

  &.is-on {
    background: linear-gradient(145deg, #16a34a, #22c55e);
    box-shadow: 0 8px 18px rgba(34, 197, 94, 0.22);
  }
}

.sec-hero-title-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.35rem;
}

.sec-hero-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--sec-ink);
}

.sec-hero-desc {
  font-size: 0.875rem;
  color: var(--sec-muted);
  line-height: 1.45;
  max-width: 52rem;
}

.sec-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 0.15rem 0.55rem;
  font-size: 0.7rem !important;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.sec-badge--ok {
  color: #15803d;
  background: #dcfce7;
  border: 1px solid #86efac;
}

.sec-badge--off {
  color: #64748b;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
}

.sec-methods {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem;
}

.sec-method {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  padding: 1.15rem;
  border-radius: 14px;
  border: 1px solid var(--sec-line);
  background: #fff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

  &:hover {
    border-color: rgba(102, 28, 176, 0.35);
    box-shadow: 0 10px 28px rgba(52, 71, 103, 0.08);
    transform: translateY(-1px);
  }
}

.sec-method-top {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.sec-method-icon {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  display: grid;
  place-items: center;
  flex-shrink: 0;

  .material-icons,
  i {
    font-size: 22px;
  }

  &--wa {
    background: #ecfdf5;
    color: #16a34a;
  }

  &--totp {
    background: #f5e9ff;
    color: var(--sec-purple);
  }
}

.sec-method-title {
  font-size: 0.98rem;
  font-weight: 700;
  color: var(--sec-ink);
}

.sec-method-desc {
  font-size: 0.84rem;
  color: var(--sec-muted);
  line-height: 1.45;
}

.sec-method-meta {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.55rem 0.7rem;
  border-radius: 10px;
  background: #f8fafc;
  color: #334155;
  font-size: 0.8rem;

  .material-icons {
    font-size: 16px;
    color: #0ea5e9;
  }

  &--muted {
    color: var(--sec-muted);

    .material-icons {
      color: #a78bfa;
    }
  }
}

.sec-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  border-radius: 10px;
  border: none;
  padding: 0.65rem 1rem;
  font-size: 0.88rem;
  font-weight: 650;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;

  .material-icons {
    font-size: 18px;
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }

  &--primary {
    color: #fff;
    background: linear-gradient(135deg, var(--sec-purple) 0%, var(--sec-pink) 100%);
    box-shadow: 0 8px 18px rgba(228, 27, 128, 0.22);

    &:hover:not(:disabled) {
      transform: translateY(-1px);
      box-shadow: 0 10px 22px rgba(102, 28, 176, 0.28);
    }
  }

  &--danger {
    width: auto;
    flex-shrink: 0;
    color: #b91c1c;
    background: #fef2f2;
    border: 1px solid #fecaca;

    &:hover:not(:disabled) {
      background: #fee2e2;
    }
  }
}

@media (max-width: 767.98px) {
  .sec-hero {
    flex-direction: column;
    align-items: stretch;
  }

  .sec-btn--danger {
    width: 100%;
  }

  .sec-methods {
    grid-template-columns: 1fr;
  }
}

/* —— Pixels & Anúncios —— */
.px-shell {
  --px-ink: #344767;
  --px-muted: #67748e;
  --px-line: #e9ecef;
  --px-soft: #f8f9fb;
  --px-accent: #661cb0;
}

.px-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.px-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.1rem 1.15rem;
  border-radius: 14px;
  border: 1px solid var(--px-line);
  background: linear-gradient(180deg, #fff 0%, var(--px-soft) 100%);
  min-height: 168px;
}

.px-card--soon {
  opacity: 0.85;
}

.px-card-top {
  display: flex;
  gap: 0.85rem;
  align-items: flex-start;
}

.px-card-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid var(--px-line);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;

  img {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }
}

.px-card-title-row {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  flex-wrap: wrap;
  margin-bottom: 0.35rem;
}

.px-card-title {
  color: var(--px-ink);
  font-weight: 700;
  font-size: 0.98rem;
}

.px-card-desc {
  color: var(--px-muted);
  font-size: 0.82rem;
  line-height: 1.35;
}

.px-badge {
  font-size: 0.68rem;
  font-weight: 700;
  padding: 0.15rem 0.45rem;
  border-radius: 999px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.px-badge--ok {
  color: #15803d;
  background: #dcfce7;
}

.px-badge--soon {
  color: #a16207;
  background: #fef9c3;
}

.px-btn {
  align-self: flex-start;
  border: 1px solid var(--px-line);
  background: #fff;
  color: var(--px-ink);
  border-radius: 10px;
  padding: 0.55rem 0.95rem;
  font-size: 0.86rem;
  font-weight: 650;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover:not(:disabled) {
    border-color: rgba(102, 28, 176, 0.35);
    background: #faf7ff;
  }

  &--primary {
    background: linear-gradient(135deg, #661cb0 0%, #e41b80 100%);
    color: #fff;
    border: none;
  }

  &--ghost {
    background: transparent;
  }

  &--disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
}

.px-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.px-modal {
  width: min(460px, 100%);
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.22);
  overflow: hidden;
}

.px-modal-header,
.px-modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 1rem 1.15rem;
}

.px-modal-footer {
  justify-content: flex-end;
  border-top: 1px solid var(--px-line);
}

.px-modal-body {
  padding: 0 1.15rem 1rem;
}

.px-modal-close {
  border: none;
  background: transparent;
  color: var(--px-muted);
  cursor: pointer;
  display: inline-flex;
  padding: 0.15rem;

  .material-icons {
    font-size: 20px;
  }
}

@media (max-width: 767.98px) {
  .px-grid {
    grid-template-columns: 1fr;
  }
}
</style>